



















import { defineComponent, ref, watch } from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'FaqSearch',
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  setup(props, { emit }) {
    const searchInput = ref(props.value);
    
    watch(() => props.value, (newValue) => {
      searchInput.value = newValue;
    });

    watch(searchInput, (newValue) => {
      emit('input', newValue);
    });

    const handleSearch = () => {
      emit('search', searchInput.value);
    };

    return {
      searchInput,
      handleSearch
    };
  }
});
